import brand from '@helpers/brand';
import fonts from '@helpers/fonts';
import { Device, from, until } from '@helpers/media';
import Containers from '@stories/Settings/Containers/Containers.styles';
import styled from 'styled-components';

const Wrapper = styled.section`
  position: relative;
  padding: 40px 0;
  background-color: ${brand.red.base};

  @media ${from(Device.TabletLarge)} {
    padding: 80px 0;
  }
`;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const TitleContainer = styled.div`
  margin-bottom: 30px;
`;

const Title = styled.div`
  ${fonts.helvetica['93-black-extended']};
  font-size: 30px;
  line-height: 28px;
  color: ${brand.white};
  text-align: center;

  @media ${until(Device.Tablet)} {
    font-size: 24px;
  }
`;

const IconsContainer = styled(Containers.Wide)`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;

  @media ${until(Device.TabletLarge)} {
    justify-content: center;
  }
`;

const Icon = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 0 0 240px;
  margin: 0 10px 20px;
`;

const IconImageContainer = styled.div`
  margin-bottom: 30px;

  svg {
    width: 122px;
    height: 122px;
  }
`;

const IconTitle = styled.div`
  ${fonts.helvetica['83-heavy-extended']};
  color: ${brand.white};
  font-size: 16px;
  text-align: center;
`;

export const CareIconsStyles = {
  Wrapper,
  Container,
  TitleContainer,
  Title,
  IconsContainer,
  Icon,
  IconImageContainer,
  IconTitle,
};
